import { offeringCourses } from "@/db/offeringData";
import Image from "next/image";
import Link from "next/link";

const CoursesArea = () => {
  return (
    <section className="home-ragular-course pb-100">
      <div className="container">
        <div className="section-tittle text-center">
          <h2>OUR OFFERINGS</h2>
          <p>
            Inspiring minds. Building CHARACTER. Empowering Future leaders.
          </p>
        </div>

        <div className="row">
          {offeringCourses.slice(0, 3).map((item) => (
            <div key={item.id} className="col-lg-4 col-md-6">
              <div className="single-ragular-course">
                <div className="course-img height-fixed">
                  <Image
                    src={item.image}
                    alt={item.title}
                    width={400}
                    height={280}
                    className="img-fluid"
                  />
                  <h2>{item.title}</h2>
                </div>

                <div className="course-content">
                  <p>{item.description}</p>
                  {/* <Link href={`/offering-details?name=${item.slug}`} className="border-btn">
                    Read More
                  </Link> */}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CoursesArea;
